import { useSession } from "../store/session";
import { currentDelegateRequestId, delegatePresentation } from "../lib/delegatePresentation";

/** Current backend-owned run only. Shares the existing per-chat Stop action. */
export default function DelegateRunBadge() {
  const companyId = useSession((s) => s.activeCompanyId);
  const statuses = useSession((s) => s.sessionStatusByCompany);
  const messages = useSession((s) => s.messagesByCompany);
  const queues = useSession((s) => s.queueByCompany);
  if (!companyId) return null;
  const status = statuses[companyId];
  const view = delegatePresentation(status, companyId,
    currentDelegateRequestId(messages[companyId] ?? [], queues[companyId] ?? []));
  if (!view) return null;
  return <span className="delegateBadge delegateBadge--live" title={view.title} role="status">
    <span>{view.label}</span>
    {view.canStop && <button type="button" className="delegateBadge__remove"
      aria-label="Stop Astra task" title="Stop this chat's current task"
      onClick={() => {
        const current = useSession.getState();
        if (current.activeCompanyId === companyId &&
            current.sessionStatusByCompany[companyId]?.delegate?.runId === status?.delegate?.runId)
          void current.interruptStream();
      }}>×</button>}
  </span>;
}
